import * as yup from 'yup';


const NAME = (type = 'Name') =>
   yup
      .string()
      .max(50, `${type} should have maximum 20 characters`)
      .matches(
         /^[A-Za-z.-]+(\s*[A-Za-z.-]+)*$/,
         `${type} should not contains numbers, spaces at first charcter & special characters`
      )
      .required(`${type} is required`);


const EMAIL = yup
   .string()
   .matches(
    /^[+\w-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/,
      'Enter a valid email'
   )
   .required('Email is required')
   .max(150, 'Email must be maximum 150 characters');



// const PHONE_NUMBER = (name) =>
//    yup
//       .string()
//       .matches(/^(\+\d{1,3}[- ]?)?\d{10}$/, `Invalid ${name}`)
//       .min(10, `${name} should be minimum 10 digits`)
//       .max(16, `${name} should be maximum 16 digits`)
//       .required(`${name} is required`)
//       .nullable();

const PASSWORD = (name = 'Password') =>
   yup
      .string()
      .matches(
         /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/,
         `${name} must be at least 8 characters long, contain at least one uppercase letter, one numeric value, and one special character`
      )
      // .matches(/.{8,15}$/, 'Password must be minimum 8 and maximum 15 characters')
      .required(`${name} is required`);

const CONFIRM_PASSWORD = (ref = 'password') =>
   yup
      .string()
      .required('Confirm password is required')
      .min(8, 'Confirm password must be minimum 8 characters')
      .max(15, 'Confirm password must be maximum 15 characters ')
      .oneOf([yup.ref(ref), null], 'Both passwords must match');


// const GENDER = yup.string().required('Gender is required');

// const ADDRESS = yup
//    .string()
//    .matches(/^[A-Za-z0-9,/_.-]+(\s*[A-Za-z0-9,/_.-]+)*$/, 'Address is not valid')
//    .required('Address is required')
//    .max(5000);

export const EmailValidator = yup.object({
   email: EMAIL,
});

export const ResumeAboutYouSchema = yup.object({
   name: NAME('Name'),
   bio: yup
   .string().nullable()
});

export const ResumeWorkExpericeSchema = yup.object({
   experiences: yup.array()
     .of(
       yup.object({
         from: yup.date()
         .nullable()
         .required('From date is required')
         .max(yup.ref('to'), 'From date cannot be after To date')
         .test('not-same', 'From date and To date cannot be the same', function (value) {
            const toDate = this.resolve(yup.ref('to'));
            const formattedFormDate = new Date(value)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            const formattedToDate = new Date(toDate)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            return formattedFormDate !== formattedToDate; // Ensure the two dates are not the same
          }),
         
         to: yup.date()
         .nullable()
         .required('To date is required')
         .min(yup.ref('from'), 'End date cannot be before From date')
         .test('not-same', 'From date and To date cannot be the same', function (value) {
            const fromDate = this.resolve(yup.ref('from'));
            const formattedFormDate = new Date(fromDate)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            const formattedToDate = new Date(value)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            
            return formattedToDate !== formattedFormDate; // Ensure the two dates are not the same
          }),
         

         role: yup.string().required("Job role is required"),
         company: yup.string().required("Company name is required"),
         responsibilities: yup.array()
            .min(1, "At least one responsibility is required")
            .required("Responsibility are required"),
         // responsibility: yup.string().required("Responsibility is required"),
       })
     )
     .min(1, "At least one experience is required"),
 });


 export const ResumeEducationSchema = yup.object({
   educations: yup.array()
     .of(
       yup.object({
         from: yup.date()
         .nullable()
         .transform((value, originalValue) =>
            originalValue ? new Date(originalValue) : null
          )
         .required('From date is required')         
         .max(yup.ref('to'), 'From date cannot be after To date')
         .test('not-same', 'From date and To date cannot be the same', function (value) {
            const toDate = this.resolve(yup.ref('to'));
            const formattedFormDate = new Date(value)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            const formattedToDate = new Date(toDate)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            return formattedFormDate !== formattedToDate; // Ensure the two dates are not the same
          }),

         to: yup.date()
         .nullable()
         .transform((value, originalValue) =>
            originalValue ? new Date(originalValue) : null
          )
         .required('To date is required')
         .min(yup.ref('from'), 'End date cannot be before From date')
         .test('not-same', 'From date and To date cannot be the same', function (value) {
            const fromDate = this.resolve(yup.ref('from'));
            const formattedFormDate = new Date(fromDate)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            const formattedToDate = new Date(value)
            .toLocaleDateString('en-GB')
            .replace(/\//g, '/');
            
            return formattedToDate !== formattedFormDate; // Ensure the two dates are not the same
          }), // Ensure to and from are not the same
                
         fieldofstudy: yup.string().required("Field of study is required"),
         degree: yup.string().required("Degree is required"),
         college: yup.string().required("College is required"),
         city: yup.string().required("City is required"),
      })
     )
     .min(1, "At least one education is required"),
 });

 export const ResumeAchievementSchema = yup.object({
   achievements: yup.array()
     .min(1, "At least one achievement is required")
     .required("Achievements are required"),
 });

 export const ResumeSkillSchema = yup.object({
   skills: yup.array()
     .min(1, "At least one skill is required")
     .required("Skills are required"),
 });

 export const ChangePasswordValidator = yup.object({
   password_old: PASSWORD('Old password'),
   password_new: PASSWORD('New password'),
   confirm_password: CONFIRM_PASSWORD('password_new'),
});

export const validationPostJob = yup.object().shape({
      jobTitle: yup
        .string()
        .trim()
        .min(2, "Minimum length should be 2")
        .required("Job Title is required"),

      jobCategory: yup.string().required("Please select a job category"),

      jobType: yup.string().required("Please select a job type"),

      salaryStart: yup
        .number()
        .typeError("Must be a number")
        .min(100, "Minimum length should be 3")
        .required("Salary start range is required"),

      salaryEnd: yup
        .number()
        .typeError("Must be a number")
        .min(
          yup.ref("salaryStart"),
          "Range must be equal or greater than previous field"
        )
        .required("Salary end range is required"),

      Experience: yup.string().required("Please select Experience"),

      Qualification: yup.string().trim().required("Qualification is required"),

      Skills: yup
        .array()
        .of(yup.string().trim().required("Skills are required"))
        .min(1, "At least one skill is required"),

      Vacancies: yup
        .number()
        .typeError("Must be a number")
        .min(1, "Minimum 1 vanacy is required")
        .required("Vacancies is required"),

      jobLocation: yup.string().trim().required("Job Location is required"),

      applicationDate: yup
        .string()
        .test("is-future-date", "Date cannot be in the past", function (value) {
            if (!value) return false;
            const selectedDate = new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0); // ignore time
            return selectedDate >= today;
         })
        .required("Application Date is required"),

      jobDescription: yup.string().required("Job Description is required"),

      Responsibilities: yup.string().required("Responsibilities is required"),

      skillDes: yup.string().required("Skills Description is required"),
    });
